import * as React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import CountUp from 'react-countup';
import ScoreUtils from 'src/utils/ScoreUtils';
import Settings from 'src/objects/Settings';

export default class PlayerStatComponent extends React.Component<any, any> {

    constructor(props:any) {
        super(props);

        this.state = {
        }
    }

    private getDamage():number {
        let damage = 0;
        damage =
            ScoreUtils.gameNegativeTotals.huge * 1000 +
            ScoreUtils.gameNegativeTotals.large * 500 +
            ScoreUtils.gameNegativeTotals.medium * 250 +
            ScoreUtils.gameNegativeTotals.small * 100 +
            ScoreUtils.gameNegativeTotals.tiny * 50;
        return damage;
    }

    private getScorePercentage(stat):number {
        let settings:Settings = this.props.settings;
        console.log("Settings:", settings, this.props)
        let scoreBand = (stat / settings.maxStat) * 100;
        return scoreBand;
    }

    private getGrade():string {
        let grade:string = "A+";
        let stat:number = this.props.userData.stat;
        let statPercentage:number = this.getScorePercentage(stat);
        if (statPercentage < 100) { grade = "A" };
        if (statPercentage < 95) { grade = "A-" };
        if (statPercentage < 90) { grade = "B+" };
        if (statPercentage < 85) { grade = "B" };
        if (statPercentage < 80) { grade = "B-" };
        if (statPercentage < 75) { grade = "C+" };
        if (statPercentage < 70) { grade = "C" };
        if (statPercentage < 60) { grade = "C-" };
        if (statPercentage < 50) { grade = "D" };
        if (statPercentage < 40) { grade = "E" };
        if (statPercentage < 30) { grade = "F" };
        return grade;
    }

    render() {
        return (
            <Grid>
                <Row id='endChapterStatContainer' className="show-grid">
                    {/* <Col xs={6} md={3}>
                        <p className='endChapterStatTitle'>Files Stolen</p>
                        <p className='endChapterStatNumber'>
                            <CountUp
                                start={0}
                                end={this.getDamage()}
                                duration={2}
                                >
                            </CountUp>
                        </p>
                    </Col> */}
                    <Col xs={6} md={3}>
                        <p className='endChapterStatTitle'>Decisions</p>
                        <p className='endChapterStatNumber'>
                            <CountUp
                                start={0}
                                end={parseInt(this.props.userData.progress)}
                                duration={2}
                                >
                            </CountUp>
                        </p>
                    </Col>
                    <Col xs={6} md={3}>
                        <p className='endChapterStatTitle'>Efficiency</p>
                        <p className='endChapterStatNumber'>
                            <CountUp
                                start={0}
                                end={parseInt(this.props.userData.stat)}
                                duration={2}
                                suffix="%"
                                >
                            </CountUp>
                        </p>
                    </Col>
                    <Col xs={6} md={3}>
                        <p className='endChapterStatTitle'>Score</p>
                        <p className='endChapterStatNumber'>
                            <CountUp
                                start={0}
                                end={parseInt(this.props.userData.score)}
                                duration={2}
                                >
                            </CountUp>
                        </p>
                    </Col>
                    <Col xs={6} md={3}>
                        <p className='endChapterStatTitle'>Grade</p>
                        <p className='endChapterStatNumber endChapterStatGrade'>{this.getGrade()}</p>
                    </Col>
                </Row>
            </Grid>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/PlayerStatComponent.tsx